<div *ngIf="observation.club === 781765" class="alert alert-warning" role="alert">
  Klubben denne rapporten ligger på er merket som en testklubb. Det betyr at den er merket som en test, og ikke vil behandlet av Luftfartstilsynet dersom den sendes inn.
</div>
